import React from 'react'
import objectPath from 'object-path'
import PropTypes from 'prop-types'

import { 
	FastField, 
	Field,
	connect as formikConnect
} from 'formik'

import moment from 'moment'

import NoValue from './NoValue'

// Special field types
import AddressHistory from './input/AddressHistory'
import Availability from './input/Availability'
import Checkbox from './input/Checkbox'
import Contacts from './input/Contacts'
import DatePicker from './input/DatePicker'
import DebounceInput from './input/DebounceInput'
import EmploymentHistory from './input/EmploymentHistory'
import FieldArray from './input/FieldArray'
import FileUpload from './input/FileUpload'
import FileUploadMulti from './input/FileUploadMulti'
import Hours from './input/Hours'
import InterviewResults from './input/InterviewResults/InterviewResults'
import JobTypeRates from './input/JobTypeRates'
import MatchedCandidates from './input/MatchedCandidates'
import RadioGroup from './input/RadioGroup'
import ResourceSelect from './input/ResourceSelect'
import ResourceIDSelect from './input/ResourceIDSelect'
import Select from './input/Select'
import TimesheetLine from './input/TimesheetLine'
import TimesheetLineArray from './input/TimesheetLineArray'
import PhoneInput from './input/PhoneInput'

const InputComponents = {
	Availability,
	// Contacts,
	DatePicker,
	FileUpload,
	FileUploadMulti,
	Hours,
	InterviewResults,
	JobTypeRates,
	MatchedCandidates,
	RadioGroup,
	ResourceSelect,
	ResourceIDSelect,
	Select,
	TimesheetLine,
	DebounceInput,
	// TimesheetLineArray,
	// TODO: refactor Checkbox to fit in here
	// Checkbox,
	// TODO: create Radio/CheckboxGroup 
}

const FormFieldDisplay = ({children}) => <div className="FormField-display">{children}</div>;

// TODO: move DisplayComponents into 
const DisplayComponents = {
	DatePicker: ({value, dateFormat}) => {
		if(!value) {
			return <NoValue />
		}
		dateFormat = dateFormat ? dateFormat : 'DD/MM/YYYY';
		var	output = moment(new Date(value)).format(dateFormat.toUpperCase());
		return <FormFieldDisplay>{output}</FormFieldDisplay>;
	},
	Default: ({value}) => {
		if(value == null
			|| ((Array.isArray(value) || typeof value === 'string') && !value.length)
		) {
			return <NoValue/>;
		}

		if(typeof value === 'boolean') value = value ? 'Yes' : 'No';

		if(typeof value === 'object') {
			value = value.label
				? value.label
				: JSON.stringify(value);
		}

		return <FormFieldDisplay>{value}</FormFieldDisplay>
	},
	Select: ({value, options}) => {
		const option = options.find(o => o.value === value);
		return option
			? <FormFieldDisplay>{option.label}</FormFieldDisplay>
			: DisplayComponents.Default({value})
	},
	RadioGroup: ({ value, options }) => {
		const option = options.find(opt => opt.value === value);
		return DisplayComponents.Default({ value: option ? option.label : value });
	},
	ResourceSelect: ({ isMulti, value }) => {
		var output = <NoValue />

		if(isMulti && value && value.length) {
			output = value.map(doc => <span key={doc._id} className="MultiItem">{doc.label}</span>)
			output = <div className="MultiItems">{output}</div>
		}
		else if(value !== null && typeof value === 'object' && value.label) {
			output = value.label;
		} 

		return <FormFieldDisplay>{output}</FormFieldDisplay>;
	},
	TimesheetLines: ({value}) => {
		return value.map((v, i) => <pre key={i}>{JSON.stringify(v)}</pre>);
	},
}

export default 
@formikConnect
class FormField extends React.Component {

	static defaultProps = {
		isEditing: true,
	};

	render() {
		const { isEditing, isNew } = this.props;
		
		return isEditing
			? this.renderInput()
			: this.renderDisplay()
	}

	renderInput() {
		const { component, isEditing, isNew, ...props } = this.props;

		switch(true) {
			
			// TODO: refactor to match the signature of the below cases and the generic cases
			case component === 'FieldArray':
				return <FieldArray {...this.props} /> 
			case component === 'TimesheetLineArray':
				return <TimesheetLineArray {...this.props} />;
			case component === 'AddressHistory':
				return <AddressHistory {...this.props} />;
			case component === 'EmploymentHistory':
				return <EmploymentHistory {...this.props} />;
			case component === 'Contacts':
				return <Contacts {...this.props} />;
			case component === 'Checkbox':
				return <Checkbox {...this.props} />;
			case component === 'PhoneInput':
				return <PhoneInput {...this.props} />;
			case component === 'JobTypeRates':
				return <Field {...this.props} component={InputComponents[component]} />
			case Object.keys(InputComponents).includes(component):
				return <FastField {...this.props} component={InputComponents[component]} />
			case typeof component === 'function':
				return <FastField {...this.props} />
			default:
				return <FastField className="FieldGroup-input" {...props} component={component} />;
		}		
	}

	renderDisplay() {
		const { component, name, formik } = this.props;

		// TODO: make this mismatch between inputs that handle display and those that dont cleaner
		var useInputForDisplay = [
			'AddressHistory',
			'EmploymentHistory',
			'Availability',
			'FieldArray',
			'Hours',
			'InterviewResults',
			'JobTypeRates',
			'MatchedCandidates',
			'TimesheetLine',
			'TimesheetLineArray',
			'FileUpload',
			'FileUploadMulti',
			'Contacts',
		];

		if(useInputForDisplay.includes(component)) {
			if(Object.keys(InputComponents).includes(component)) {
				// this is here include of using renderInput so that FastField can be used
				// TODO: refactor so that display & input are distinct without this workaround
				return <Field {...this.props} component={InputComponents[component]} />;
			} else {
				return this.renderInput();
			}
		}

		const value = objectPath(formik.values).get(name)

		var DisplayComponent = DisplayComponents[component]
			? DisplayComponents[component]
			: DisplayComponents.Default;

		return <DisplayComponent {...this.props} value={value} />
	}

	renderOptions(options) {
		if(!options || !options.length) return '';
		return [
			<option key={0} disabled value=''>--select an option--</option>,
			...options.map((option, idx) => 
				<option key={option.value+'-'+(idx+1)} value={option.value}>{option.value}</option>
			)
		];
	}

}


// WEBPACK FOOTER //
// ./src/modules/form/components/FormField.jsx